import React from 'react';
import { Container } from '@infoods/lifebase-ui';

import classes from './NgzAccountSetup.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { AccountSetupBanner } from './AccountSetupBanner/AccountSetupBanner';
import { ResourceLibrary } from '../../containers/ResourceLibrary/ResourceLibrary';
import { VIDEO_PAGE } from '../../constants/videoPage';

const NgzAccountSetup = () => {
  return (
    <Container className={classes.container}>
      <AccountSetupBanner />
      <div>
        <ResourceLibrary page={VIDEO_PAGE.ACCOUNT_SETUP} />
      </div>
    </Container>
  );
};

angularizeWithProviders(NgzAccountSetup, 'ngzAccountSetup', {});
